import DataTableTask from './DataTableTask'

export default DataTableTask
